exports.lang = {
    "kr": "vi",
    "아프리카TV | 투표" : "AfreecaTV | Bỏ phiếu",
    "투표" : "Bỏ phiếu",
    "투표 등록" : "Đăng ký bỏ phiếu",
    "투표 수정" : "Bỏ phiếu sửa đổi",
    "투표 등록 및 수정" : "Đăng ký bỏ phiếu và chỉnh sửa",
    "종류" : "Các loại",
    "기본형" : "Loại cơ bản",
    "1:1 투표" : "1 đến 1 phiếu",
    "제목" : "Tiêu đề",
    "투표 제목을 입력해주세요." : "Vui lòng nhập tiêu đề của phiếu bầu.",
    "항목을 입력해주세요." : "Vui lòng nhập mục.",
    "기간" : "Kỳ hạn",
    "투표 종료일" : "Ngày kết thúc bỏ phiếu",
    "종료일" : "Ngày cuối",
    "설정" : "Cài đặt",
    "복수 선택 허용" : "Cho phép nhiều lựa chọn",
    "결과 미리보기 허용" : "Cho phép xem trước kết quả",
    "체크 박스를 해제하시면 투표에 참여하기 전 또는 투표가 종료될 때까지 모든 참여자가 투표 결과를 확인할 수 없습니다." : "Nếu bạn xóa hộp kiểm, tất cả người tham gia sẽ không thể xem kết quả bỏ phiếu trước hoặc cho đến khi kết thúc bỏ phiếu.",
    "수정" : "Sửa đổi",
    "닫기" : "Đóng",
    "삭제" : "Xóa bỏ",
    "등록" : "Đăng ký",
    "투표 항목을 입력해주세요." : "Vui lòng nhập mục bỏ phiếu.",
    "투표 항목은 최소 2개 이상 등록해야 합니다." : "Vui lòng đăng ký ít nhất 2 mục bỏ phiếu.",
    "투표는 최대 3개까지 등록할 수 있습니다." : "Bạn có thể đăng ký tối đa 3 phiếu.",
    "투표 항목은 최대 10개까지 만들 수 있습니다." : "Bạn có thể tạo tối đa 10 mục bỏ phiếu.",
    "투표 제목은 최대 30자까지 입력할 수 있습니다." : "Bạn có thể nhập tối đa 30 ký tự cho tiêu đề bỏ phiếu.",
    "투표 항목은 최대 10자까지 입력할 수 있습니다." : "Bạn có thể nhập tối đa 10 ký tự cho mục bỏ phiếu.",
    "올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요." : "Định dạng tập tin không chính xác. Đảm bảo phần mở rộng tập tin là JPG, GIF.",
    "파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다." : "Kích thước tệp vượt quá 10 MB và không thể đăng ký.",
    "선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요." : "Kích thước của tệp GIF đã chọn vượt quá 200KB và không thể đăng ký được. Vui lòng kiểm tra lại kích thước tệp.",
    "투표 기간을 설정해주세요." : "Vui lòng đặt thời gian bỏ phiếu.",
    "오늘보다 이전 날짜 또는 시간은 설정할 수 없습니다." : "Bạn không thể đặt ngày hoặc thời gian sớm hơn hôm nay.",
    "입력하신 내용이 모두 초기화됩니다. 투표 형식을 변경하시겠습니까?" : "Tất cả mọi thứ bạn nhập sẽ được thiết lập lại. Bạn có muốn thay đổi định dạng bỏ phiếu?",
    "투표가 수정되었습니다." : "Bỏ phiếu đã được sửa chữa.",
    "투표를 삭제하시겠습니까?" : "Bạn có muốn xóa phiếu bầu?",
    "해당 투표 항목을 삭제하시겠습니까?" : "Bạn có muốn xóa mục bình chọn này?",
    "투표하기" : "VOTE",
    "결과 미리보기" : "Xem trước",
    "다시 투표하기" : "Bỏ phiếu một lần nữa",
    "전체 참여자" : "Tổng số người tham gia",
    "명" : "",
    "투표하러 가기" : "Đi bỏ phiếu",
    "현재시간 이후를 선택해주세요." : "Vui lòng chọn sau thời gian hiện tại.",
    "투표 종료일을 3개월 이내로 선택해주세요." : "Vui lòng chọn ngày kết thúc bỏ phiếu trong vòng 3 tháng.",
    "투표가 등록되었습니다." : "Bạn đã đăng ký bình chọn của mình.",
    "투표를 등록한 유저가 삭제한 투표입니다." : "Một phiếu bầu bị xóa bởi người dùng đã đăng ký phiếu bầu.",
    "다른 투표에 참여해주세요." : "Vui lòng tham gia các cuộc thăm dò khác.",
    "투표에 참여 완료되었습니다." : "Tham gia bỏ phiếu đã hoàn tất.",
    "투표 종료" : "Kết thúc VOTE",
    "투표를 종료하시겠습니까?" : "Bạn có muốn kết thúc bỏ phiếu không?",
    "항목 추가" : "Thêm mặt hàng",
    "취소" : "Hủy bỏ",
    "시" : "giờ",
    "분" : "phút",
    "이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다.": "Khi đăng ký hình ảnh bình chọn 1: 1, bạn phải đính kèm tất cả các hình ảnh bình chọn để đăng ký.",
    "무승부" : "cà vạt",
    "무승부 항목 추가" : "Thêm mặt hàng",
}